import { schema } from 'normalizr';
import { buildPaymentGatewayProfileIdentifier } from 'store/schemas/utils';

// SCHEMAS
const company = new schema.Entity('companies');
const cruiseLine = new schema.Entity('cruiseLines');
const cruiseLineInclude = new schema.Entity('cruiseLineIncludes');
const cruiseLineItinerary = new schema.Entity('cruiseLineItineraries');
const cruiseLinePhoto = new schema.Entity('cruiseLinePhotos');
const cruiseLinePort = new schema.Entity('cruiseLinePorts');
const cruiseLineSailing = new schema.Entity('cruiseLineSailings');
const cruiseLineSailingDocument = new schema.Entity('cruiseLineSailingDocuments');
const cruiseLineShip = new schema.Entity('cruiseLineShips');
const emailTemplate = new schema.Entity('emailTemplates');
const currency = new schema.Entity('currencies');
const destination = new schema.Entity('destinations');
const defaultService = new schema.Entity('defaultServices');
const externalIdentifier = new schema.Entity('externalIdentifiers');
const hotel = new schema.Entity('hotels');
const hotelRatePlan = new schema.Entity('hotelRatePlans');
const destinationDocument = new schema.Entity('destinationDocument');
const insurance = new schema.Entity('insurances');
const member = new schema.Entity('members');
const memberCreditCardDescription = new schema.Entity('memberCreditCardDescriptions');
const memberEmail = new schema.Entity('memberEmails');
const memberAssistant = new schema.Entity('memberAssistants');
const memberPhone = new schema.Entity('memberPhones');
const memberTrip = new schema.Entity('memberTrips');
const memberReward = new schema.Entity('memberRewards');
const memberRewardComponent = new schema.Entity('memberRewardComponents');
const oauthAccessToken = new schema.Entity('oauthAccessToken');
const oauthClient = new schema.Entity('oauthClients');
const oauthClientRedirectUrl = new schema.Entity('oauthClientRedirectUrls');
const packageOffer = new schema.Entity('packageOffers');
const packageOfferService = new schema.Entity('packageOfferServices');
const paymentMethod = new schema.Entity('paymentMethods');
const paymentProcess = new schema.Entity('paymentProcesses');
const paymentGatewayProfile = new schema.Entity('paymentGatewayProfiles', {}, {
    idAttribute: (value) => buildPaymentGatewayProfileIdentifier(value.payment_gateway, value.local_type, value.local_id),
});
const memberReport = new schema.Entity('memberReports');
const zinrelo = new schema.Entity('zinrelos');
const refund = new schema.Entity('refunds');
const reservationRelation = new schema.Entity('reservationRelations');
const request = new schema.Entity('requests');
const requestDocument = new schema.Entity('requestDocuments');
const requestQuote = new schema.Entity('requestQuotes');
const requestQuoteComponent = new schema.Entity('requestQuoteComponents');
const reservation = new schema.Entity('reservations');
const reservationAudit = new schema.Entity('reservation_audits');
const reservationCancellationApproval = new schema.Entity('reservationCancellationApprovals');
const reservationCancellationNumber = new schema.Entity('reservationCancellationNumbers');
const reservationComponentHistory = new schema.Entity('reservationComponentHistories');
const reservationCruise = new schema.Entity('reservationCruises');
const reservationCruiseCabin = new schema.Entity('reservationCruiseCabins');
const reservationCruiseNumbers = new schema.Entity('reservationCruiseNumbers');
const reservationDocument = new schema.Entity('reservationDocuments');
const reservationFlight = new schema.Entity('reservationFlights');
const reservationFlightNumbers = new schema.Entity('reservationFlightNumbers');
const reservationFlightLeg = new schema.Entity('reservationFlightLegs');
const reservationHotel = new schema.Entity('reservationHotels');
const reservationHotelNumbers = new schema.Entity('reservationHotelNumbers');
const reservationHotelRoom = new schema.Entity('reservationHotelRooms');
const reservationInsurance = new schema.Entity('reservationInsurances');
const reservationInsuranceNumbers = new schema.Entity('reservationInsuranceNumbers');
const reservationInformativeInvoice = new schema.Entity('reservationInformativeInvoices');
const reservationInvoice = new schema.Entity('reservationInvoices');
const reservationMember = new schema.Entity('reservationMembers');
const reservationService = new schema.Entity('reservationServices');
const reservationServiceNumbers = new schema.Entity('reservationServiceNumbers');
const reservationTransaction = new schema.Entity('reservationTransactions');
const reservationTransactionComponent = new schema.Entity('reservationTransactionComponents');

const reservationTransactionLog = new schema.Entity('reservationTransactionLogs');
const role = new schema.Entity('roles');
const transactionTemplate = new schema.Entity('transactionTemplates');
const transactionTemplateComponent = new schema.Entity('transactionTemplateComponents');
const travelerPreference = new schema.Entity('travelerPreferences');
const user = new schema.Entity('users');
const authUser = new schema.Entity('authUser');
const travelAgency = new schema.Entity('travelAgencies');
const userTemplate = new schema.Entity('userTemplates');
const vendor = new schema.Entity('vendors');
const vendorService = new schema.Entity('vendorServices');

// MORPH ENTITIES
const PaymentMethodEntityMorph = new schema.Union({
    Hotel: hotel,
    Vendor: vendor,
}, (value, parent) => parent.entity_type);

const PaymentProcessEntityMorph = new schema.Union({
    Hotel: hotel,
    Vendor: vendor,
}, (value, parent) => parent.entity_type);

const refundComponentMorph = new schema.Union({
    ReservationCruise: reservationCruise,
    ReservationFlight: reservationFlight,
    ReservationHotel: reservationHotel,
    ReservationInsurance: reservationInsurance,
    ReservationService: reservationService,
}, (value, parent) => parent.component_type);

const reservationCancellationNumberMorph = new schema.Union({
    Cruise: reservationCruise,
    Flight: reservationFlight,
    Hotel: reservationHotel,
    Insurance: reservationInsurance,
    Service: reservationService,
}, (value, parent) => parent.component_type);

const reservationTransactionComponentMorph = new schema.Union({
    ReservationCruise: reservationCruise,
    ReservationFlight: reservationFlight,
    ReservationHotel: reservationHotel,
    ReservationInsurance: reservationInsurance,
    ReservationService: reservationService,
}, (value, parent) => parent.component_type);

const transactionTemplateEntityMorph = new schema.Union({
    Reservation: reservation,
    Request: request,

}, (value, parent) => parent.type);

const transactionTemplateComponentMorph = new schema.Union({
    ReservationCruise: reservationCruise,
    ReservationFlight: reservationFlight,
    ReservationHotel: reservationHotel,
    ReservationInsurance: reservationInsurance,
    ReservationService: reservationService,
}, (value, parent) => parent.component_type);

const memberRewardComponentMorph = new schema.Union({
    ReservationCruise: reservationCruise,
    ReservationFlight: reservationFlight,
    ReservationHotel: reservationHotel,
    ReservationInsurance: reservationInsurance,
    ReservationService: reservationService,
}, (value, parent) => parent.component_type);

// RELATIONS
company.define({ parent: company });
cruiseLine.define({
    cruiseLineIncludes: [cruiseLineInclude],
    cruiseLinePhotos: [cruiseLinePhoto],
});
cruiseLineItinerary.define({ cruiseLinePorts: [cruiseLinePort] });
cruiseLineSailing.define({
    cruiseLine,
    cruiseLineShip,
    cruiseLineItinerary,
    cruiseLinePorts: [cruiseLinePort],
    cruiseLineSailingDocuments: [cruiseLineSailingDocument],
    packageOffer,
});
hotel.define({
    destination,
    hotelRatePlans: [hotelRatePlan],
    defaultService,
});
destination.define({ destinationDocuments: [destinationDocument] });
hotelRatePlan.define({
    hotel,
});
member.define({
    company,
    externalIdentifiers: [externalIdentifier],
    parent: member,
    user,
    memberCreditCardDescriptions: [memberCreditCardDescription],
    memberEmails: [memberEmail],
    travelAgency,
    memberPhones: [memberPhone],
    travelerPreferences: [travelerPreference],
    memberTrips: [memberTrip],
    memberRewards: [memberReward],
    previousProfiles: [member],
});
memberAssistant.define({
    assistant: member,
});

memberTrip.define({
    member,
});
memberReward.define({
    member,
    memberRewardComponents: [memberRewardComponent],
});
memberRewardComponent.define({
    memberReward,
    component: memberRewardComponentMorph,
});
oauthClient.define({
    oauthAccessTokens: [oauthAccessToken],
    oauthClientRedirectUrls: [oauthClientRedirectUrl],
});
packageOffer.define({ cruiseLineSailing, packageOfferServices: [packageOfferService] });
packageOfferService.define({ service: vendorService, vendor });
paymentMethod.define({
    entity: PaymentMethodEntityMorph,
    vendor,
});
paymentProcess.define({
    entity: PaymentProcessEntityMorph,
});
requestQuote.define({
    request,
    requestQuoteComponents: [requestQuoteComponent],
    transactionTemplates: [transactionTemplate],
});
request.define({
    externalIdentifiers: [externalIdentifier],
    requestDocuments: [requestDocument],
    requestQuotes: [requestQuote],
    member,
    user,
});
refund.define({
    component: refundComponentMorph,
    reservation,
});

memberReport.define({
    reservations: [reservation],
    requests: [request],
});

reservation.define({
    externalIdentifiers: [externalIdentifier],
    refunds: [refund],
    reservationRelations: [reservationRelation],
    request,
    reservationAssistants: [memberAssistant],
    reservationCancellationApproval,
    reservationCancellationNumbers: [reservationCancellationNumber],
    reservationComponentHistories: [reservationComponentHistory],
    reservationCruises: [reservationCruise],
    reservationDocuments: [reservationDocument],
    reservationFlights: [reservationFlight],
    reservationHotels: [reservationHotel],
    reservationInformativeInvoices: [reservationInformativeInvoice],
    reservationInsurances: [reservationInsurance],
    reservationInvoices: [reservationInvoice],
    reservationMembers: [reservationMember],
    reservationServices: [reservationService],
    transactions: [reservationTransaction],
    transactionTemplates: [transactionTemplate],
});
reservationCancellationApproval.define({ approvedBy: user });
reservationCancellationNumber.define({ component: reservationCancellationNumberMorph });
reservationCruise.define({ numbers: reservationCruiseNumbers, currency, reservationCruiseCabins: [reservationCruiseCabin] });
reservationFlight.define({ currency, numbers: reservationFlightNumbers, legs: [reservationFlightLeg] });
reservationHotel.define({ currency, reservationHotelRooms: [reservationHotelRoom], numbers: reservationHotelNumbers });
reservationInsurance.define({ currency, insurance, numbers: reservationInsuranceNumbers });
reservationMember.define({ member });
reservationRelation.define({
    reservation,
    relatedReservation: reservation,
});
reservationService.define({
    currency, reservation, service: vendorService, numbers: reservationServiceNumbers,
});
reservationTransaction.define({
    components: [reservationTransactionComponent],
    currency,
    member,
    reservationTransactionLog,
});
reservationTransactionComponent.define({
    component: reservationTransactionComponentMorph,
});

transactionTemplate.define({
    currency,
    entity: transactionTemplateEntityMorph,
    transactionTemplateComponents: [transactionTemplateComponent],
});

transactionTemplateComponent.define({
    component: transactionTemplateComponentMorph,
});

user.define({ alternativeUser: user });
userTemplate.define({ user });
vendor.define({ vendor });

// EXPORTS
export const companySchema = company;
export const cruiseLineSchema = cruiseLine;
export const cruiseLineIncludeSchema = cruiseLineInclude;
export const cruiseLineItinerarySchema = cruiseLineItinerary;
export const cruiseLinePhotoSchema = cruiseLinePhoto;
export const cruiseLinePortSchema = cruiseLinePort;
export const cruiseLineSailingSchema = cruiseLineSailing;
export const cruiseLineSailingDocumentSchema = cruiseLineSailingDocument;
export const cruiseLineShipSchema = cruiseLineShip;
export const emailTemplateSchema = emailTemplate;
export const currencySchema = currency;
export const defaultServiceSchema = defaultService;
export const destinationSchema = destination;
export const destinationDocumentSchema = destinationDocument;
export const externalIdentifierSchema = externalIdentifier;
export const hotelSchema = hotel;
export const hotelRatePlanSchema = hotelRatePlan;
export const insuranceSchema = insurance;
export const memberSchema = member;
export const memberRewardSchema = memberReward;
export const memberRewardComponentSchema = memberRewardComponent;
export const memberEmailSchema = memberEmail;
export const memberAssistantSchema = memberAssistant;
export const memberPhoneSchema = memberPhone;
export const memberTripSchema = memberTrip;
export const oauthClientSchema = oauthClient;
export const oauthClientRedirectUrlSchema = oauthClientRedirectUrl;
export const packageOfferSchema = packageOffer;
export const packageOfferServiceSchema = packageOfferService;
export const paymentMethodSchema = paymentMethod;
export const paymentProcessSchema = paymentProcess;
export const paymentGatewayProfileSchema = paymentGatewayProfile;
export const requestSchema = request;
export const requestDocumentSchema = requestDocument;
export const requestQuoteSchema = requestQuote;
export const refundSchema = refund;
export const reservationSchema = reservation;
export const memberReportSchema = memberReport;
export const zinreloSchema = zinrelo;
export const reservationAuditSchema = reservationAudit;
export const reservationCancellationApprovalSchema = reservationCancellationApproval;
export const reservationCancellationNumberSchema = reservationCancellationNumber;
export const reservationComponentHistorySchema = reservationComponentHistory;
export const reservationCruiseSchema = reservationCruise;
export const reservationCruiseCabinSchema = reservationCruiseCabin;
export const reservationCruiseNumbersSchema = reservationCruiseNumbers;
export const reservationFlightSchema = reservationFlight;
export const reservationFlightNumbersSchema = reservationFlightNumbers;
export const reservationFlightLegSchema = reservationFlightLeg;
export const reservationHotelSchema = reservationHotel;
export const reservationHotelNumbersSchema = reservationHotelNumbers;
export const reservationHotelRoomSchema = reservationHotelRoom;
export const reservationInformativeInvoiceSchema = reservationInformativeInvoice;
export const reservationInsuranceSchema = reservationInsurance;
export const reservationInsuranceNumbersSchema = reservationInsuranceNumbers;
export const reservationInvoiceSchema = reservationInvoice;
export const reservationMemberSchema = reservationMember;
export const reservationRelationSchema = reservationRelation;
export const reservationServiceSchema = reservationService;
export const reservationServiceNumbersSchema = reservationServiceNumbers;
export const reservationTransactionSchema = reservationTransaction;
export const reservationTransactionComponentSchema = reservationTransactionComponent;
export const reservationTransactionLogSchema = reservationTransactionLog;
export const roleSchema = role;
export const transactionTemplateSchema = transactionTemplate;
export const travelerPreferenceSchema = travelerPreference;
export const userSchema = user;
export const authUserSchema = authUser;
export const travelAgencySchema = travelAgency;
export const userTemplateSchema = userTemplate;
export const vendorSchema = vendor;
export const vendorServiceSchema = vendorService;
